import BasicTheme from '../components/themes/basicTheme';
import { useParams } from 'react-router-dom';


function BookReader() {
  
  const { book_id } = useParams();

  const renderTheme = () => {
        return <BasicTheme book_id={book_id}/>;
  };
  return (
    <div className="book-reader-container">
       {renderTheme()}
    </div>
  );
}

export default BookReader;
